import * as React from "react";
import { Select,Button,Input,Icon,Upload, message,Tooltip } from 'antd';
import SmallTools from "widget/smallTools";
import _ from "lodash";

const Option = Select.Option;


interface Data {
  travelInfo: any;
  driverInfo: any;
  passengerInfo: any;
  orderInfo: any;
  data: any;
  getTraveler?:any;
  updateDataValue:any;
  readonly:any;
  orderDetails:any;
  id:any;
  orderStatus:any;
  ErrorInfo:any;
}

class travelInfo extends React.Component<Data> {
  state = {
    travelInfo:[],
    driverInfo:[],
    passengerInfo:[],
    orderInfo:[],
    data:{},
    travelerData:[],
    num:0,
    name:'',
    readonly:{},
    orderDetails:{},
    isOpen:'shrink',
    openTitle:'展开',
    field:[],
    ErrorInfo:{},
  };

  constructor(props: Data) {
    super(props);
  }

  difference(object, base) {
    function changes(object, base) {
      return _.transform(object, function(result, value, key) {
        if (!_.isEqual(value, base[key])) {
          result[key] =
            _.isObject(value) && _.isObject(base[key])
              ? changes(value, base[key])
              : value;
        }
      });
    }
    return changes(object, base);
  }

  shouldComponentUpdate(nextProps: any, prevState: any) {
    if(!nextProps.orderInfo){
      return false;
    }
    const keys = Object.keys(
      this.difference(nextProps.ErrorInfo, this.state.ErrorInfo)
    );
    if (prevState.orderInfo.length != nextProps.orderInfo.length || keys.length > 0) {
      this.setState({
        travelInfo: nextProps.travelInfo ? nextProps.travelInfo :[],
        passengerInfo: nextProps.passengerInfo ? nextProps.passengerInfo : [] ,
        driverInfo:nextProps.driverInfo ? nextProps.driverInfo:[],
        orderInfo:nextProps.orderInfo ? nextProps.orderInfo:[],
        data:nextProps.data,
        readonly:nextProps.readonly,
        orderDetails:nextProps.orderDetails,
        ErrorInfo:nextProps.ErrorInfo,
      });  
      if(nextProps.orderDetails['phone']){
        this.getTra(nextProps.orderDetails['phone']);
      }
      return false;
    }
    return true;
  }

  changeOpen = () =>{
    if(this.state.isOpen == 'shrink'){
      this.setState({
        isOpen: 'open',
        openTitle:'收起',
      });
    }else{
      this.setState({
        isOpen:'shrink',
        openTitle:'展开',
      });      
    }
  } 

  mapRadio = (list) =>{
      return(list.map((item) =>{
          return(<Option key={item}>{item}</Option>);
      }))
  }
  
  selectTra = (key) => {
    const val = this.state.travelerData[key]['data']; 
    const name = this.state.name;
    if(name == '乘客'){
      for (let value of this.state.passengerInfo) {
        this.changeValue(this.state.data[value['id']],value['id'],this.state.num,val);
      }  
    }else if(name == '司机'){
      for (let value of this.state.driverInfo) {
        this.changeValue(this.state.data[value['id']],value['id'],this.state.num,val);
      }  
    }else{
      for (let value of this.state.travelInfo) {
        this.changeValue(this.state.data[value['id']],value['id'],this.state.num,val);
      }      
    }   
  }

  changeValue = (value, id, num, val) => {
    let data = this.state.data;
    if (data[id] == ""){
      data[id] = [];
    }
    if(value.length < num){
      data[id].push(val[id]) 
    }else{
      const listItems =  value.map((item,key) =>{
        if(key+1 == num){
          return val[id];
        }else{
          return item;
        }
       })  
       data[id] = listItems;
       this.props.updateDataValue({id:id,value:listItems});
    }
    
    this.setState({
       data:data
    });
  }
  
  delValue = (id,num) => {
    let data = this.state.data;
    if(data[id].length < num){
       return;
    }
    data[id].splice(num-1, 1);
    this.setState({
      data:data
   });  
  }

  onFocusTra = (num,name) =>{  
      this.setState({
          num:num,
          name:name
      });  
  }
  container=()=>{
    //console.log(document.getElementsByTagName("div"))
    return document.getElementsByTagName("div")[91]
 } 
  delTra = (num,name) => {
    let data = this.state.data;
    if(name == '成人'){
      data['3'] = data['3']-1;
      this.setState({
         data:data
      });   
      this.props.updateDataValue({id:'3',value:data['3']});    
    }
    if(name == '儿童'){
      data['4'] = data['4']-1;
      this.setState({
         data:data
      });  
      this.props.updateDataValue({id:'4',value:data['4']});      
    }  
    if(name == '婴儿'){
      data['6'] = data['6']-1;
      this.setState({
         data:data
      }); 
      this.props.updateDataValue({id:'6',value:data['6']});       
    } 
    if(name == '乘客'){
      data['162'] = data['162']-1;
      this.setState({
         data:data
      }); 
      this.props.updateDataValue({id:'162',value:data['162']});   
      for (let value of this.state.passengerInfo) {
        this.delValue(value['id'],num);
      }     
    }else if(name == '司机'){
      data['161'] = data['161']-1;
      this.setState({
         data:data
      }); 
      this.props.updateDataValue({id:'161',value:data['161']});   
      for (let value of this.state.driverInfo) {
        this.delValue(value['id'],num);
      }   
    }else{
        for (let value of this.state.travelInfo) {
          this.delValue(value['id'],num);
        }
    }  
  }

  onChange = (num,id,value) =>{
    if(value instanceof Object){
      let data = this.state.data;
      if (data[id] == ""){
        data[id] = [];
      }
      let arr:any = data[id];
      
      if(arr.length < num){
        data[id].push(value.target.value);
      }else{
          const listItems =  arr.map((item,key) =>{
            if(key+1 == num){
              return value.target.value;
            }else{
              return item;
            }
          })
          console.log(listItems);
         this.props.updateDataValue({id:id,value:listItems}); 
      }
      this.setState({
        data:data
      });     
    }else{
      let data = this.state.data;
      if (data[id] == ""){
        data[id] = [];
      }
      let arr:any = data[id];
      
      if(arr.length < num){
        data[id].push(value);
      }else{
          const listItems =  arr.map((item,key) =>{
            if(key+1 == num){
              return value;
            }else{
              return item;
            }
          })
          console.log(listItems);
         this.props.updateDataValue({id:id,value:listItems}); 
      }
      this.setState({
        data:data
      });     
    }  
  }

  listMap = (num,name) =>{
    let numx = num;
    if(name == '儿童'){
      num = num+Number(this.state.data['3']);
    } 
    if(name == '婴儿'){
      num = num+Number(this.state.data['3'])+Number(this.state.data['4']);
    }
    if(name == '乘客'){
      if(this.state.passengerInfo.length != 0){
          var listItems =  this.state.passengerInfo.map((item,key) =>{
            if(item['f_type'] == 'text'){
              return(<Tooltip getPopupContainer={this.container}  visible={this.state.ErrorInfo[item['id']] && this.state.ErrorInfo[item['id']][num-1] ? true : false} placement="top"  title={this.state.ErrorInfo[item['id']] ? this.state.ErrorInfo[item['id']][num-1] :''}><Input disabled={this.state.readonly[item['id']]}  key={item['id']} placeholder={item['ch_name']} value={this.state.data[item['id']][num-1]} onFocus={this.onFocusTra.bind(this,num,name)} onChange={this.onChange.bind(this,num,this.state.passengerInfo[key]['id'])} /></Tooltip>); 
            }else if(item['f_type'] == 'radio'){
              const options = this.mapRadio(item['rvalue']);
              return(<Tooltip getPopupContainer={this.container}  visible={this.state.ErrorInfo[item['id']] && this.state.ErrorInfo[item['id']][num-1] ? true : false} placement="top"  title={this.state.ErrorInfo[item['id']] ? this.state.ErrorInfo[item['id']][num-1] :''}><Select disabled={this.state.readonly[item['id']]} key={item['id']} value={this.state.data[item['id']][num-1]} onChange={this.onChange.bind(this,num,this.state.passengerInfo[key]['id'])} showSearch optionFilterProp="children" >{options}</Select></Tooltip>);           
            }else{
              return false;
            }
          }) 
          return(
            <div className="travel-list">
                <div className="travel-li">
                <div className="title">{name} {numx}  <Icon type="delete" onClick={this.delTra.bind(this,num,name)} /></div> 
                <div className="list">
                {listItems} 
                </div>
                </div>
            </div>
          )
      }else{
        return false;
      }
    }else if(name == '司机'){
      if(this.state.driverInfo.length != 0){
        var listItems =  this.state.driverInfo.map((item,key) =>{
          if(item['f_type'] == 'text'){
            return(<Tooltip getPopupContainer={this.container}  visible={this.state.ErrorInfo[item['id']] && this.state.ErrorInfo[item['id']][num-1] ? true : false} placement="top"  title={this.state.ErrorInfo[item['id']] ? this.state.ErrorInfo[item['id']][num-1] :''}><Input disabled={this.state.readonly[item['id']]}  key={item['id']} placeholder={item['ch_name']} value={this.state.data[item['id']][num-1]} onFocus={this.onFocusTra.bind(this,num,name)} onChange={this.onChange.bind(this,num,this.state.driverInfo[key]['id'])} /></Tooltip>); 
          }else if(item['f_type'] == 'radio'){
            const options = this.mapRadio(item['rvalue']);
            return(<Tooltip getPopupContainer={this.container}  visible={this.state.ErrorInfo[item['id']] && this.state.ErrorInfo[item['id']][num-1] ? true : false} placement="top"  title={this.state.ErrorInfo[item['id']] ? this.state.ErrorInfo[item['id']][num-1] :''}><Select disabled={this.state.readonly[item['id']]} key={item['id']} value={this.state.data[item['id']][num-1]} onChange={this.onChange.bind(this,num,this.state.driverInfo[key]['id'])} showSearch optionFilterProp="children" >{options}</Select></Tooltip>);           
          }else{
            return false;
          }
        }) 
        return(
          <div className="travel-list">
              <div className="travel-li">
              <div className="title">{name} {numx}  <Icon type="delete" onClick={this.delTra.bind(this,num,name)} /></div> 
              <div className="list">
              {listItems} 
              </div>
              </div>
          </div>
        )
    }else{
      return false;
    }
    }else{
      if(this.state.travelInfo.length != 0){
          var listItems =  this.state.travelInfo.map((item,key) =>{
            if(item['f_type'] == 'text'){
              return(<Tooltip getPopupContainer={this.container}  visible={this.state.ErrorInfo[item['id']] && this.state.ErrorInfo[item['id']][num-1] ? true : false} placement="top"  title={this.state.ErrorInfo[item['id']] ? this.state.ErrorInfo[item['id']][num-1] :''}><Input disabled={this.state.readonly[item['id']]}  key={item['id']} placeholder={item['ch_name']} value={this.state.data[item['id']][num-1]} onFocus={this.onFocusTra.bind(this,num,name)} onChange={this.onChange.bind(this,num,this.state.travelInfo[key]['id'])} /></Tooltip>); 
            }else if(item['f_type'] == 'radio'){
              const options = this.mapRadio(item['rvalue']);
              return(<Tooltip getPopupContainer={this.container}  visible={this.state.ErrorInfo[item['id']] && this.state.ErrorInfo[item['id']][num-1] ? true : false} placement="top"  title={this.state.ErrorInfo[item['id']] ? this.state.ErrorInfo[item['id']][num-1] :''}><Select disabled={this.state.readonly[item['id']]} key={item['id']} value={this.state.data[item['id']][num-1]} onChange={this.onChange.bind(this,num,this.state.travelInfo[key]['id'])} showSearch optionFilterProp="children" >{options}</Select></Tooltip>);           
            }else{
              return false;
            }
          })
          return(
            <div className="travel-list">
                <div className="travel-li">
                <div className="title">{name} {numx}  <Icon type="delete" onClick={this.delTra.bind(this,num,name)} /></div> 
                <div className="list">
                {listItems} 
                </div>
                </div>
            </div>
          )
       }else{
          return false;
       }
   }
  }  

  creatFrom = () => {
    let list : any = []; 
    for (let i in this.state.data ){
       if(i == '3'){
        for (let num =1; num<=this.state.data[i]; num++) {
          list.push(this.listMap(num,'成人'));   
        }
       }
       if(i == '4'){
        for (let num =1; num<=this.state.data[i]; num++) {
          list.push(this.listMap(num,'儿童')); 
        }
       }
       if(i == '6'){
        for (let num =1; num<=this.state.data[i]; num++) {
          list.push(this.listMap(num,'婴儿'));    
        }
       }
       if(i == '162'){
        for (let num =1; num<=this.state.data[i]; num++) {
          list.push(this.listMap(num,'乘客'));    
        }
       }
       if(i == '161'){
        for (let num =1; num<=this.state.data[i]; num++) {
          list.push(this.listMap(num,'司机'));    
        }
       }
    }
    return <React.Fragment>{list}</React.Fragment>;
  };

  getTraveler = () => {
     const listItems = this.state.travelerData.map((item,key) => {
           return(<Button key={key} className={key<3 ? 'open' : this.state.isOpen} onClick={this.selectTra.bind(this,key)}>{item['ch_name']}</Button>)
     })
     if(this.state.travelerData.length > 3){
      listItems.push(<Button type="primary" onClick={this.changeOpen}>{this.state.openTitle}</Button>);
    }    
     return <React.Fragment>{listItems}</React.Fragment>;
  }

  getTra = (phone) =>{
    const param: any = {
      phone:phone
    };
    this.props.getTraveler({
      ...param,
      callback: (data) => {
        this.setState({
          travelerData: data,
        });
      }
     });
  }
  
  upload = (event) => {
    event.fileList.map((item) =>{
      if(item.response){
            message.info(item.response.info);
            setTimeout(() => {
              window.location.reload();
            }, 1000);  
            return; 
      }
     }); 
    this.setState({
      field:event.fileList
    });
  }

  render() {
    if(this.state.travelInfo.length == 0 && this.state.passengerInfo.length == 0 && this.state.driverInfo.length == 0 ){
        return false;
    }else{
      const url ="https://erpapi.cattrip.net/api/order/importTravelInfo/"+this.props.id;
      return (
        <td>
        <div className='order-info'>
        <div className={(this.props.orderStatus == "0") ? '' : 'hide'}>
        <div className="upload-box" >
        <Upload accept=".xls,.xlsx" fileList={this.state.field}   action={url} name='importTravel' onChange={this.upload} ><Button><Icon type="upload" />导入出行人</Button></Upload>
        </div>
        </div>
        <div className="used">
        <SmallTools
            content={this.getTraveler()}
            isOpenEnlarge={false}
            isOpenFieldDrawer={false}
        />
        </div>
        <SmallTools
            content={this.creatFrom()}
            isOpenEnlarge={false}
            isOpenFieldDrawer={false}
        />            
        </div> 
        </td>
      );
    }
  }
}

export default travelInfo

